export default () => {
  const skeleton = document.getElementById('skeleton-loader');

  const showSkeleton = () => {
    if (!skeleton) return;
    skeleton.style.display = 'block';
  };

  const hideSkeleton = () => {
    if (!skeleton) return;
    skeleton.style.display = 'none';
  };

  return {
    showSkeleton,
    hideSkeleton,
  };
};
